import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";


// Async thunk for fetching data
export const fetchMetaIntegrationExistDataSlice = createAsyncThunk(
    "metaIntegration/fetchData",
    async ({ rejectWithValue }) => {
        const url = ENDPOINTS.FBINTEGRATION.GET_FB_INTEGRATION;
        try {
            const response = await axios.get(url);
            return response.data?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const metaIntegrationSlice = createSlice({
    name: "metaIntegration",
    initialState: {
        data: null,
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMetaIntegrationExistDataSlice.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMetaIntegrationExistDataSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchMetaIntegrationExistDataSlice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default metaIntegrationSlice.reducer;